/* eslint-disable no-unused-vars */
import ensurePath from 'redux/ensurePath'
import immerize from '../immerize'

const initialState = {
  status: '',
  error: null,
  actives: {
    byid: {},
    list: [],
  },
}

function reducer(state = initialState, action) {
  let data
  switch (action.type) {
    case 'CLEAR_STORE':
      state = initialState
      break
    case 'TRACKERS_ACTIVES_INIT':
      data = action.payload.data
      ensurePath(state, ['actives'])

      state.actives = data.actives
      state.status = 'TRACKERS_ACTIVES_INIT'
      break
    case 'TRACKERS_TOUR_START':
      data = action.payload.data
      trackersTourStart(state, data.id, data.info)
      break
    case 'TRACKERS_TOUR_END':
      data = action.payload.data
      trackersTourEnd(state, data)
      break
    case 'TRACKERS_TOUR_ROUTE':
      data = action.payload.data
      trackersTourRoute(state, data)
      break
    case 'TRACKERS_PANIC_START':
      data = action.payload.data
      trackersPanicStart(state, data)
      break
    case 'TRACKERS_PANIC_STOP':
      data = action.payload.data
      trackersPanicStop(state, data)
      break
    case 'TRACKERS_TOUR_VISITED':
      data = action.payload.data
      trackersTourVisited(state, data)
      break
    default:
      return state
  }
  return state
}

function trackersTourStart(state, trackerId, tracker) {
  const actives = ensurePath(state, ['actives'])
  const byid = ensurePath(state, ['actives', 'byid'])

  actives.list = actives.list ?? []

  if (
    actives.list.find((id) => {
      return id === trackerId
    })
  ) {
    return
  }

  Object.keys(tracker.byid).forEach((key) => {
    byid[key] = tracker.byid[key]
  })
  actives.list = [...actives.list, ...tracker.list]
}

function trackersTourEnd(state, trackerId) {
  const trackerIdKey = '' + trackerId

  const actives = ensurePath(state, ['actives'])
  const byid = ensurePath(state, ['actives', 'byid'])

  actives.list = actives.list ?? []

  if (byid[trackerIdKey]) {
    delete byid[trackerIdKey]
  }

  const index = actives.list.indexOf(trackerId)
  if (index !== -1) {
    actives.list.splice(index, 1)
  }
}

function trackersTourRoute(state, data) {
  const actives = ensurePath(state, ['actives'])
  actives.list = actives.list ?? []

  if (
    !actives.list.find((e) => {
      return e === data.trackerId
    })
  ) {
    return
  }
  const trackerIdKey = '' + data.trackerId
  const route = ensurePath(state, ['actives', 'byid', trackerIdKey, 'route'])
  const routeById = ensurePath(state, [
    'actives',
    'byid',
    trackerIdKey,
    'route',
    'byid',
  ])
  route.list = route.list ?? []

  Object.keys(data.path).forEach((key) => {
    routeById[key] = data.path[key]
  })
  route.list = [...route.list, data.route[data.trackerId]]
}

function trackersPanicStart(state, data) {
  const { info, trackerId } = data

  const actives = ensurePath(state, ['actives'])
  const byid = ensurePath(state, ['actives', 'byid'])

  actives.list = actives.list ?? []
  if (
    !actives.list.find((i) => {
      return i === data.trackerId
    })
  ) {
    return
  }

  const trackerIdKey = '' + trackerId

  byid[trackerIdKey] = byid[trackerIdKey] ?? {}
  const tracker = byid[trackerIdKey]

  tracker.panic = tracker.panic ?? {}
  tracker.route = tracker.route ?? {}

  const panic = tracker.panic
  const route = tracker.route

  Object.keys(info.panic[trackerIdKey]).forEach((key) => {
    panic[key] = info.panic[trackerIdKey][key]
  })
  tracker.isPanic = true

  route.byid = route.byid ?? {}
  route.list = route.list ?? []

  const routeById = route.byid
  const routeList = route.list

  Object.keys(info.path).forEach((key) => {
    routeById[key] = info.path[key]
  })
  route.list = [...routeList, ...info.route[trackerId]]
}

function trackersPanicStop(state, trackerId) {
  const actives = ensurePath(state, ['actives'])

  actives.list = actives.list ?? []
  if (
    !actives.list.find((i) => {
      return i === Number(trackerId)
    })
  ) {
    return
  }

  const trackerIdKey = '' + trackerId

  actives.byid = actives.byid ?? {}
  const activesById = actives.byid

  actives.list = actives.list ?? []
  const activesList = actives.list

  activesById[trackerIdKey] = activesById[trackerIdKey] ?? {}
  const tracker = activesById[trackerIdKey]

  if (tracker.isPanic) {
    if (!tracker.isTour) {
      const index = activesList.indexOf(trackerId)
      if (index !== -1) {
        activesList.splice(index, 1)
      }
      delete activesById[trackerIdKey]
      return
    } else {
      tracker.isPanic = false
    }
  }
  tracker.panic = {}
}

function trackersTourVisited(state, data) {
  const activeTrackersById = ensurePath(state, ['actives', 'byid'])
  if (!activeTrackersById[data.tracker_id]) {
    return
  }

  const trackerId = data.tracker_id
  const trackerIdKey = '' + trackerId
  const point = data.point

  activeTrackersById[trackerIdKey] = activeTrackersById[trackerIdKey] ?? {}
  const tracker = activeTrackersById[trackerIdKey]

  tracker.tour = tracker.tour ?? {}
  const tour = tracker.tour

  tour.visited = tour.visited ?? {}
  const visited = tour.visited

  activesByidIdTourVisited(visited, point)
}

function activesByidIdTourVisited(visited, point) {
  visited.byid = visited.byid ?? {}
  visited.list = visited.list ?? []

  const byid = visited.byid
  const list = visited.list

  if (!byid[point.serialNumber]) {
    visited.list = [...list, point.serialNumber]
    byid[point.serialNumber] = {
      byid: {
        [point.id]: point,
      },
      list: [point.id],
    }
    return
  }

  byid[point.serialNumber] = byid[point.serialNumber] ?? {}
  const serialNumber = byid[point.serialNumber]

  serialNumber.byid[point.id] = serialNumber.byid[point.id] ?? {}
  if (serialNumber.byid[point.id]) {
    return visited
  }
  serialNumber.byid[point.id] = point
  serialNumber.list = [...serialNumber.list, point.id]
}

export default immerize(reducer)
